<template>
  <header
    class="gap-6 items-center mx-auto max-w-screen-xl flex flex-col text-center justify-center py-8 px-4 lg:py-12 lg:px-6"
  >
    <div class="font-light text-gray-500 sm:text-lg">
      <h2 class="mb-4 text-3xl tracking-tight font-semibold text-gray-900">
        Neuigkeiten aus der Manege
      </h2>
      <p class="mb-4">
        Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten und
        Ankündigungen des Circus St.Ottilien. Hier finden Sie spannende
        Informationen über unsere kommenden Veranstaltungen, besondere
        Ereignisse und vieles mehr. Verpassen Sie keine Neuigkeiten aus der
        Manege!
      </p>
    </div>
  </header>
</template>
